import { HeadCell } from '../../../models/TableProps';
import {
    InvoiceData,
    InvoiceDetailsData,
    InvoiceHeadCellContent,
} from '../../../models/Invoice';
import { BasicHeadCell } from '../../../models/BasicTable/BasicTableProps';

export const INVOICE_HEAD_CELLS: HeadCell<InvoiceHeadCellContent>[] = [
    {
        id: 'invoiceNumber',
        numeric: false,
        disablePadding: false,
        label: 'INVOICE_NUMBER',
        sortable: true,
    },
    {
        id: 'date',
        numeric: true,
        disablePadding: false,
        label: 'DATE',
        sortable: true,
    },
    {
        id: 'paid',
        numeric: true,
        disablePadding: false,
        label: 'PAID',
        sortable: true,
    },
    {
        id: 'paymentDeadline',
        numeric: true,
        disablePadding: false,
        label: 'PAYMENT_DEADLINE',
        sortable: true,
    },
    {
        id: 'price_net',
        numeric: true,
        disablePadding: false,
        label: 'PRICE_NET',
        sortable: true,
    },
    {
        id: 'price_gross',
        numeric: true,
        disablePadding: false,
        label: 'PRICE_GROSS',
        sortable: true,
    },
    {
        id: 'status',
        numeric: true,
        disablePadding: false,
        label: 'STATUS',
        sortable: true,
    },
    {
        id: 'shopifyOrderId',
        numeric: true,
        disablePadding: false,
        label: 'SHOPIFY_ORDER_ID',
        sortable: true,
    },
    {
        id: 'more',
        numeric: true,
        disablePadding: false,
        label: 'MORE',
        sortable: false,
    },
];

export const INVOICE_DETAILS_HEAD_CELLS: BasicHeadCell<InvoiceData>[] = [
    {
        id: 'invoiceNumber',
        disablePadding: true,
        label: 'INVOICE_NUMBER',
    },
    {
        id: 'date',
        disablePadding: false,
        label: 'DATE',
    },
    {
        id: 'paid',
        disablePadding: false,
        label: 'PAID',
    },
    {
        id: 'paymentDeadline',
        disablePadding: false,
        label: 'PAYMENT_DEADLINE',
    },
    {
        id: 'price_net',
        disablePadding: false,
        label: 'PRICE_NET',
    },
    {
        id: 'price_gross',
        disablePadding: false,
        label: 'PRICE_GROSS',
    },
    {
        id: 'status',
        disablePadding: false,
        label: 'STATUS',
    },
];

export const INVOICE_PRODUCTS_HEAD_CELLS: HeadCell<InvoiceDetailsData>[] = [
    {
        id: 'lineObjectNumber',
        disablePadding: true,
        label: 'SKU',
        numeric: false,
        sortable: true,
    },
    {
        id: 'description',
        disablePadding: false,
        label: 'TITLE',
        numeric: false,
        sortable: true,
    },
    {
        id: 'quantity',
        disablePadding: false,
        label: 'QUANTITY',
        numeric: false,
        sortable: false,
    },
    {
        id: 'unitPrice',
        disablePadding: false,
        label: 'UNIT_PRICE',
        numeric: false,
        sortable: true,
    },
    {
        id: 'netAmount',
        disablePadding: false,
        label: 'NET',
        numeric: false,
        sortable: true,
    },
    {
        id: 'netAmountIncludingTax',
        disablePadding: false,
        label: 'GROSS',
        numeric: false,
        sortable: true,
    },
];
